import { LockOutlined } from "@ant-design/icons";
import { Form, Input } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const ConfirmPassword = ({
  label = null,
  confirmField = "password",
  ...rest
}) => {
  const { t } = useTranslation();

  const rules = [
    { required: true, message: t("auth:form.confirmPassword.errors.empty") },
    ({ getFieldValue }) => ({
      validator(_, value) {
        if (!value || getFieldValue(confirmField) === value) {
          return Promise.resolve();
        }
        return Promise.reject(
          new Error(t("auth:form.confirmPassword.errors.dontMatch"))
        );
      },
    }),
  ];

  return (
    <Form.Item
      name="confirmPassword"
      label={label}
      dependencies={[confirmField]}
      rules={rules}
      hasFeedback
      required
      {...rest}
    >
      <Input.Password
        data-testid="confirmPassword"
        placeholder={label ?? t("auth:form.confirmPassword.label")}
        prefix={<LockOutlined className="inputIcon" />}
      />
    </Form.Item>
  );
};

ConfirmPassword.propTypes = {
  label: PropTypes.string,
  confirmField: PropTypes.string,
};

export default ConfirmPassword;
